import * as form from '../form';

export const substanceAlcoholSupplemental = (data = {}) => {
  const items = ((data.List || {}).items || []).map((x) => {
    const xitem = x.Item || {};
    return {
      Item: {
        CounselingDates: form.daterange(xitem.CounselingDates),
        TreatmentProviderName: form.text(xitem.TreatmentProviderName),
        TreatmentProviderAddress: form.location(xitem.TreatmentProviderAddress),
        ConsultationComment: form.textarea(xitem.ConsultationComment),
      },
    };
  });
  return {
    AlcoholTreatmentOrCounselingAnswer: form.branch(data.AlcoholTreatmentOrCounselingAnswer),
    AlcoholTreatmentOrCounselingComment: form.textarea(data.AlcoholTreatmentOrCounselingComment),
    AlcoholTreatmentOrCounselingSummaryComment: form.textarea(data.AlcoholTreatmentOrCounselingSummaryComment),
    List: form.collection(items, (data.List || {}).branch),
  };
};
